/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, Card, CardContent, CardHeader, Stack, Typography } from '@mui/material'
import { CarrierType, IssueStatus } from '@planning/app/api'
import { usePlanningStore } from '@planning/AppProvider'
import { IRailVisitItem } from '@planning/rt-stores/railVisit/RailVisitItem'
import { IVesselVisitItem } from '@planning/rt-stores/vesselVisit/VesselVisitItem'
import { useTranslate } from '@tolgee/react'
import { DashboardTile, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

interface Props {
  visitType: CarrierType
  vesselVisitItem?: IVesselVisitItem
  railVisitItem?: IRailVisitItem
  onViewClick: (e: any) => void
  unresolvedOperationsIssueCount?: number
}

export const IssueDashboardCard = observer(
  ({
    vesselVisitItem,
    railVisitItem,
    visitType,
    onViewClick,
    unresolvedOperationsIssueCount,
  }: Props) => {
    const { t } = useTranslate()
    const { issueItemStore } = usePlanningStore()
    const theme = useMinimalsTheme()

    const items = visitType === CarrierType.Vessel ? vesselVisitItem : railVisitItem

    const ordersIds = items?.orders?.map(o => o.id)
    const containerIds = items?.orders.map(o => o.container?.id)
    const matchingIssues = [
      ...issueItemStore.notResolvedItemsWithObjectTypeOrder.filter(issue =>
        ordersIds?.includes(issue.data.objectId),
      ),
      ...issueItemStore.notResolvedItemsWithObjectTypeContainer.filter(issue =>
        containerIds?.includes(issue.data.objectId),
      ),
    ]

    const unresolvedCount =
      matchingIssues.filter(issue => issue.data.issueStatus === IssueStatus.Unresolved).length +
      (unresolvedOperationsIssueCount ?? 0)

    const needFollowUpCount = matchingIssues.filter(
      issue => issue.data.issueStatus === IssueStatus.FollowUp,
    ).length

    return (
      <Card sx={{ width: '100%', height: '100%' }}>
        <CardHeader
          action={
            <Button color='inherit' onClick={onViewClick}>
              {t('view', 'View')}
            </Button>
          }
          title={<Typography variant='h2'>{t('issues', 'Issues')}</Typography>}
        />
        <CardContent sx={{ minHeight: '100%' }}>
          <Stack direction='row' gap={theme.customSpacing.xxl}>
            <DashboardTile label={t(IssueStatus.Unresolved)} value={unresolvedCount} />
            <DashboardTile label={t(IssueStatus.FollowUp)} value={needFollowUpCount} />
          </Stack>
        </CardContent>
      </Card>
    )
  },
)
